import React from 'react';
import Script from 'next/script';

const ThirdPartyScript = ({ GTM_CONTAINER_ID, ADOBE_CONTAINER_ID }) => {
  return (
    <>
      {ADOBE_CONTAINER_ID && (
        <Script
          src={`https://assets.adobedtm.com/7775c4dadf1a/f0ea7a20c511/${ADOBE_CONTAINER_ID}`}
          async
        />
      )}
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`}
      />
      {/* {STYLISTICS_API && <Script async src={STYLISTICS_API} />} */}
    </>
  );
};

export default ThirdPartyScript;
